import Button from '@/components/Buttons/Button';
import useChartImageExport from '@/components/Chart/hooks/useChartImageExport';
import { useExport } from '@/features/DataHub/modules/Export/context/ExportContext';
import { useExportSettingsActions } from '@/features/DataHub/modules/Export/hooks';
import { useAppDispatch } from '@/hooks/redux-hooks';
import { closeDrawer } from '@/slices/drawerSlice';

import type { ExportingMimeTypeValue } from 'highcharts';

const ImageFooterButtons = () => {
  const dispatch = useAppDispatch();
  const { capturePosthogEvent } = useExport();
  const { onExport } = useChartImageExport();
  const { exportSettings, updateExportSetting } = useExportSettingsActions();

  const handleButtonClick = () => {
    if (exportSettings.exportSubType) {
      capturePosthogEvent();
      onExport(exportSettings.exportSubType as ExportingMimeTypeValue);
      updateExportSetting('exportSubType', undefined);
    }
  };
  return (
    <>
      <Button
        sx={{
          color: 'primary.main',
          borderColor: 'primary.main'
        }}
        variant='outlined'
        onClick={() => {
          dispatch(closeDrawer());
        }}
      >
        Cancel
      </Button>
      <Button
        key='download'
        variant='contained'
        onClick={() => {
          handleButtonClick();
        }}
      >
        Download
      </Button>
    </>
  );
};

export default ImageFooterButtons;
